import { userData } from "./constants";
import { printLogs } from "./Utilities";

export const saveToLocalStorage = (key, value) => {
    try {
        const serializedValue = JSON.stringify(value);
        localStorage.setItem(key, serializedValue);
    } catch (error) {
        printLogs('Error saving to localStorage', error);
    }
};

export const getFromLocalStorage = (key) => {
    try {
        const serializedValue = localStorage.getItem(key);
        return serializedValue ? JSON.parse(serializedValue) : null;
    } catch (error) {
        printLogs('Error getting data from localStorage', error);
        return null;
    }
};

export const removeFromLocalStorage = (key) => {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        printLogs('Error removing data from localStorage', error);
    }
};

export const clearLocalStorage = () => {
    try {
        localStorage.clear();
    } catch (error) {
        printLogs("Error clearing localStorage", error);
    }
};

export const clearLocalStorageExceptUser = () => {
    const userDataValue = getFromLocalStorage(userData);
    clearLocalStorage();
    if (userDataValue) {
        saveToLocalStorage(userData, userDataValue);
    }
};
